

document.addEventListener('DOMContentLoaded', function() {

    const searchInputAjax = document.querySelector('#search-term-value');
    const searchInputSearchpage = document.querySelector('#search_term-search_page');

    function addSearchTermGlobalVar(e) {

        // console.log('function ran');  

        let searchTerm; 

        if (searchInputAjax.value) {
            searchTerm = searchInputAjax.value;
            // console.log('ajax');
            
        } else if (searchInputSearchpage) {
            searchTerm = searchInputSearchpage.value;
            // console.log('searchinput');
        } else {
            // console.log('neither');

        }

        let currentHref = e.target.href;

        if (currentHref.includes('?')) {
            // URL already has other query parameters, append with '&'
            currentHref += `&q=${searchTerm}`;
        } else if (searchTerm) {
            // URL has no query parameters, append with '?'
            currentHref += `?q=${searchTerm}`;
        }

        console.log(currentHref);
    
        window.location.href = currentHref;
        
        
    }

    // Event listener trigger element for regular buttons
    const searchButtons = document.querySelectorAll('.empty-search-function');

    searchButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            addSearchTermGlobalVar(e);
        })
    })

    // Ancestor trigger element for Ajax element
    const ajaxSearchContainer = document.querySelector('.search-bar__results-inner');

    ajaxSearchContainer.addEventListener('click', function(e) {
        if (e.target.matches('.empty-search-function')) {
            e.preventDefault();
            addSearchTermGlobalVar(e);
            console.log('success')
        } else {
            console.log('failed')
            console.log(e.target);
        }
    })
});


